import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { doc, getDoc, collection, query, where, onSnapshot } from 'firebase/firestore';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import '../Profile.css';

function Profile() {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userOrders, setUserOrders] = useState([]);
  const [activeTab, setActiveTab] = useState('orders');
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, async (user) => {
    // 1. ഫോൺ നമ്പർ കൃത്യമായി എടുക്കുന്നു
    const savedPhone = localStorage.getItem('userPhone');
    let phone = savedPhone;

    if (!phone && user) {
      // +971 അല്ലെങ്കിൽ മറ്റേതെങ്കിലും കൺട്രി കോഡ് ഒഴിവാക്കി നമ്പർ മാത്രം എടുക്കുന്നു
      phone = user.phoneNumber?.replace(/\D/g, '').slice(-9); 
      if (phone) localStorage.setItem('userPhone', phone);
    }

    if (phone) {
      try {
        // User Data Fetching
        const userRef = doc(db, "users", phone);
        const docSnap = await getDoc(userRef);
        if (docSnap.exists()) {
          setUserData(docSnap.data());
        } else {
          setUserData({ fullName: "Guest User", phone: phone });
        }

        // 2. Orders Query (Indexing പ്രശ്നം ഒഴിവാക്കാൻ താൽക്കാലികമായി orderBy ഒഴിവാക്കി നോക്കാം)
        const q = query(
          collection(db, "bookings"),
          where("customerPhone", "==", phone)
          // ഇവിടെ ആദ്യം orderBy ഇല്ലാതെ ചെക്ക് ചെയ്യുക, ഡാറ്റ വരുന്നുണ്ടെങ്കിൽ മാത്രം ഇൻഡക്സ് സെറ്റ് ചെയ്യാം
        );

        const unsubOrders = onSnapshot(q, (snapshot) => {
          const orders = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          
          // ക്ലയന്റ് സൈഡിൽ സോർട്ട് ചെയ്യാം (ഇൻഡക്സ് എറർ ഒഴിവാക്കാൻ)
          const sortedOrders = orders.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds);
          
          setUserOrders(sortedOrders);
          setLoading(false);
        }, (error) => {
          console.error("Firestore Error:", error);
          setLoading(false);
        });

        return () => unsubOrders();

      } catch (error) {
        console.error("Profile Fetch Error:", error);
        setLoading(false);
      }
    } else {
      setLoading(false);
      navigate('/');
    }
  });

  return () => unsubscribe();
}, [navigate]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem('userPhone');
      navigate('/');
    } catch (error) {
      console.error("Logout Error:", error);
    }
  };

  const toggleOrderDetails = (orderId) => {
    setExpandedOrderId(expandedOrderId === orderId ? null : orderId);
  };

  if (loading) {
    return (
      <div className="profile-loader-container">
        <div className="loader-spinner"></div>
        <p>Loading Profile...</p>
      </div>
    );
  }

  return (
    <div className="profile-page-wrapper">
      {/* SIDEBAR */}
      <aside className="profile-side-nav">
        <div className="nav-user-info">
          <div className="nav-avatar"><i className="fas fa-user-circle"></i></div>
          <h3>{userData?.fullName}</h3>
          <p>+971 {userData?.phone}</p>
        </div>
        <nav className="nav-links">
          <button className={activeTab === 'orders' ? 'active' : ''} onClick={() => setActiveTab('orders')}>
            <i className="fas fa-shopping-bag"></i> <span>My Orders</span>
          </button>
          <button className={activeTab === 'settings' ? 'active' : ''} onClick={() => setActiveTab('settings')}>
            <i className="fas fa-user-cog"></i> <span>Profile Settings</span>
          </button>
          <button onClick={() => navigate('/booking')}>
            <i className="fas fa-plus-circle"></i> <span>New Booking</span>
          </button>
          <button className="logout-btn-container" onClick={handleLogout}>
            <i className="fas fa-sign-out-alt"></i> <span>Logout</span>
          </button>
        </nav>
      </aside>

      {/* MAIN CONTENT */}
      <main className="profile-main-content">
        <div className="section-header">
          <h2>{activeTab === 'orders' ? "My Orders" : "Account Settings"}</h2>
          {activeTab === 'orders' && <span className="order-count">{userOrders.length} Orders</span>}
        </div>

        {activeTab === 'orders' ? (
          <div className="orders-list-container">
            {userOrders.length === 0 ? (
               <div className="no-orders">No orders found.</div>
            ) : (
              userOrders.map(order => (
                <div key={order.id} className="order-item-card">
                   <div className="order-card-header" onClick={() => toggleOrderDetails(order.id)}>
                      <div className="order-id-grp">
                        <small>ORDER ID</small>
                        <span>#{order.id.slice(0,8).toUpperCase()}</span>
                      </div>
                      <div className="header-right">
                        <span className={`order-status-badge ${order.orderStatus?.toLowerCase()}`}>
                          {order.orderStatus}
                        </span>
                        <i className={`fas fa-chevron-${expandedOrderId === order.id ? 'up' : 'down'} toggle-icon`}></i>
                      </div>
                   </div>
                   
                   <div className="order-card-body">
                      <div className="order-info">
                        <p><strong>Date:</strong> {order.createdAt?.toDate().toLocaleDateString()}</p>
                        <p><strong>Total:</strong> AED {order.payment?.totalPayable}</p>
                      </div>
                      <button className="view-details-btn" onClick={() => toggleOrderDetails(order.id)}>
                        {expandedOrderId === order.id ? "Hide Details" : "View Details"}
                      </button>
                   </div>

                   {expandedOrderId === order.id && (
                     <div className="order-details-expanded">
                        <div className="detail-section">
                          <h4>BOOKED ITEMS</h4>
                          {order.cart?.map((item, idx) => (
                            <div key={idx} className="item-row-minimal">
                              <span>{item.name} <small>x{item.quantity}</small></span>
                              <strong>AED {(item.offerPrice * item.quantity).toFixed(2)}</strong>
                            </div>
                          ))}
                        </div>

                        <div className="schedule-info">
                          <div className="sched-item">
                            <p><i className="fas fa-truck-loading"></i> Pickup</p>
                            <span>{order.scheduling?.pickup?.date}</span>
                          </div>
                          <div className="sched-item text-right">
                            <p><i className="fas fa-truck"></i> Delivery</p>
                            <span>{order.scheduling?.dropoff?.date}</span>
                          </div>
                        </div>

                        <div className="order-total-bar">
                          <span>Total Paid</span>
                          <span>AED {order.payment?.totalPayable}</span>
                        </div>
                     </div>
                     
                   )}
                </div>
              ))
            )}
          </div>
        ) : (
          <div className="settings-grid">
             <div className="setting-field">
               <label>Full Name</label>
               <input type="text" value={userData?.fullName} readOnly />
             </div>
             <div className="setting-field">
               <label>Phone Number</label>
               <input type="text" value={userData?.phone} readOnly />
             </div>
          </div>
        )}
      </main>
    </div>
  );
}

export default Profile;